var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordeye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.998,
    height: 25,
    viewBox: "0 0 25.998 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(462.882 -150.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M-453.568,170.479c-.682-.308-1.366-.58-2.016-.918a17.707,17.707,0,0,1-5.391-4.471c-.625-.746-1.18-1.55-1.771-2.324a.516.516,0,0,1-.02-.673,22.165,22.165,0,0,1,5.5-5.8,13.2,13.2,0,0,1,5.661-2.365,11.713,11.713,0,0,1,6.511.883l.325.14c.007,0,.018,0,.058-.008l.96-1.684q.7-1.221,1.391-2.443a.819.819,0,0,1,1.27-.38c.668.379.808.78.469,1.376q-5.874,10.317-11.75,20.633-.648,1.138-1.3,2.277a.85.85,0,0,1-1.34.361.871.871,0,0,1-.568-.9,1.22,1.22,0,0,1,.155-.428c.575-1.023,1.158-2.042,1.738-3.062C-453.638,170.618-453.6,170.539-453.568,170.479Zm6.449-11.307,1.32-2.32c-.07-.037-.108-.062-.15-.079a9.684,9.684,0,0,0-7.517-.127,15.567,15.567,0,0,0-6.512,5.163,1,1,0,0,0,.035,1.269,17.092,17.092,0,0,0,5.03,4.433,10.849,10.849,0,0,0,2.47,1.012l1.334-2.35a4.041,4.041,0,0,1-2.262-5.9A3.993,3.993,0,0,1-447.118,159.172Zm-2.572,1.092a2.128,2.128,0,0,0-2.174,2.329,2.089,2.089,0,0,0,1.766,1.591.283.283,0,0,0,.2-.135c.527-.914,1.044-1.833,1.572-2.747a.232.232,0,0,0-.029-.31A1.831,1.831,0,0,0-449.691,160.264Z",
    transform: "translate(0)",
    fill: "#8f8f8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M-212.743,289.881c.453-.795.869-1.529,1.292-2.259a.289.289,0,0,1,.169-.116,13.722,13.722,0,0,0,6.892-4.341c.335-.36.651-.738.963-1.118a1.053,1.053,0,0,0,0-1.526c-.785-.86-1.6-1.693-2.4-2.537-.025-.026-.046-.054-.079-.094l1.066-1.872c.571.553,1.131,1.071,1.663,1.616a24.774,24.774,0,0,1,2.6,3.232.631.631,0,0,1,.031.783,21.59,21.59,0,0,1-5.986,6.1,13.11,13.11,0,0,1-5.218,2.028C-212.061,289.828-212.37,289.844-212.743,289.881Z",
    transform: "translate(-236.453 -118.865)",
    fill: "#8f8f8f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordeye);
export default __webpack_public_path__ + "static/media/passwordeye.6e939f25292da30a783eb7f9cd773e66.svg";
export { ForwardRef as ReactComponent };